import { render, staticRenderFns } from "./LanguagesMenu.vue?vue&type=template&id=e7e6152a&scoped=true"
import script from "./LanguagesMenu.vue?vue&type=script&lang=js"
export * from "./LanguagesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e6152a",
  null
  
)

export default component.exports